import { format, parseISO } from 'date-fns';
import { DATE_FORMAT } from '@client/definitions/api';
import { DRAFT_DATE_NEW_FUNDRAISER } from '@client/definitions/constants';

export const setFundraiserDraftDate = () => {
  return format(parseISO(DRAFT_DATE_NEW_FUNDRAISER), DATE_FORMAT);
};
